import { getUrlFromLink } from 'lib/helpers'
import Marquee from 'react-fast-marquee'
import { CloseIcon } from 'components/Global/CloseIcon'
import Link from 'next/link'

export const Announcement = ({
  backgroundColor,
  textColor,
  link,
  message,
  closeBanner,
}) => {
  return (
    <div className="fixed top-0 z-[9] w-full text-11 md:text-11">
      <div
        className="flex w-full justify-between gap-10 px-20 py-[5px] md:gap-20"
        style={{
          backgroundColor: backgroundColor?.hex ?? '#FFD800',
          color: textColor?.hex ?? '#000000',
        }}
      >
        <div className="w-[14px] md:w-[40px]"></div>
        <Marquee
          gradient={true}
          gradientColor={
            backgroundColor
              ? `rgba(${backgroundColor.rgb.r}, ${backgroundColor.rgb.g}, ${backgroundColor.rgb.b}, 1)`
              : 'rgba(0, 0, 0, 0)'
          }
          gradientWidth={32}
          autoFill={true}
          speed={16}
        >
          <Link
            href={getUrlFromLink(link) ?? ''}
            scroll={false}
            className="mr-[4px]"
          >
            {message}
          </Link>
        </Marquee>
        <button
          onClick={closeBanner}
          className="flex w-[14px] items-center justify-end uppercase md:w-[40px]"
        >
          <CloseIcon fill="#000" />
        </button>
      </div>
    </div>
  )
}
